import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
};
const DefaultColor = "#58bf00";
function GAS({
  size = 16,
  color = DefaultColor
}: Props): JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path  d="M18.375 16.935l-5.242-2.443V9.076l5.242-1.859zM10.742 19.5l-5.117-2.384V7.469l5.117 2.385zM18.25 6.868l-.085.03-5.032 1.786-.126.045-2.133.756-5.047-2.352 7.18-2.548.063-.022.132-.047.047-.016 5.047 2.352-.047.016" /></Svg>;
}
GAS.DefaultColor = DefaultColor;
export default GAS;